import { Routes, Route } from 'react-router-dom'

import { Login } from '@src/pages/Login/Login'
import { Registration } from '@src/pages/Registration/Registration'
import { RecoveryPassword } from '@src/pages/RecoveryPassword/RecoveryPassword'
import { MyPoints } from '@src/pages/MyPoints/MyPoints'
import { Profile } from '@src/pages/Profile/Profile'
import { MyPurchases } from '@src/pages/Purchases/MyPurchases'
import { Chips } from '@src/pages/Chips/Chips'
import { ProductGroup } from '@src/pages/ProductGroup/ProductGroup'
import { ChangePassword } from '@src/pages/ChangePassword/ChangePassword'
import { Error404 } from '@src/pages/Errors/Error404'
import { PrivateRoute } from '@src/routes/PrivateRoute'
import { ActivationCard } from '@src/pages/ActivationCard/ActivationCard'
import { Coupons } from '@src/pages/Coupons/Coupons'

export const RoutesProject = () => (
  <Routes>
    {/* Логин */}
    <Route path="/lk/login" element={<Login />} />
    {/* Регистрация */}
    <Route path="/lk/registration" element={<Registration />} />
    {/* Активация карты */}
    <Route path="/lk/activation" element={<ActivationCard />} />
    {/* <Route path="/lk/activationPhoneCode" element={<ActivationPhoneCodeForm />} /> */}

    {/* Забыли пароль */}
    <Route path="/lk/recovery-password" element={<RecoveryPassword />} />

    <Route
      path="/lk/points"
      element={
        <PrivateRoute Component={<MyPoints />} />
      }
    />

    {/* Мой профиль */}
    <Route
      path="/lk/profile"
      element={
        <PrivateRoute Component={<Profile />} />
      }
    />
    <Route
      path="/lk/purchases"
      element={
        <PrivateRoute Component={<MyPurchases />} />
      }
    />
    <Route
      path="/lk/chips"
      element={
        <PrivateRoute Component={<Chips />} />
      }
    />
    <Route
      path="/lk/product-group"
      element={
        <PrivateRoute Component={<ProductGroup />} />
      }
    />
    <Route
      path="/lk/password-change"
      element={
        <PrivateRoute Component={<ChangePassword />} />
      }
    />
    <Route path="/lk/coupons" element={<PrivateRoute Component={<Coupons />} />} />
    <Route path="*" element={<Error404 />} />
  </Routes>
)
